<script>
  export default {
    props: {
      value: {
        required: false,
      },

      options: {
        type: Array,
        required: true,
      },
    },
  };
</script>

<template>
  <div class="switch">
    <button
      :key="key"
      class="switch__button"
      v-for="(key, index) in options"
      @click.prevent="$emit('input', index)"
      :class="{ 'switch__button--active': index === value }"
      >
      {{ key }}

      <slot v-bind="{ key, index }"></slot>
    </button>
  </div>
</template>

<style lang="scss">
  .switch {
    display: flex;
    border-radius: 4px;
    margin-bottom: 24px;
    background: #37384e;
    letter-spacing: 0.32px;

    &__button {
      flex: 1;
      height: 47px;
      color: #8e95a9;
      border-radius: 4px;

      &:hover {
        background-color: rgba(#FFF, .1);
      }

      &--active {
        color: #FFF;
        background: #3e388b !important;
      }
    }
  }
</style>
